import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiFailShield = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_30308_5680)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M18 9V0.869565C18 0.638942 17.9138 0.417765 17.7604 0.25469C17.6069 0.0916148 17.3988 0 17.1818 0H0.818182C0.601187 0 0.393079 0.0916148 0.23964 0.25469C0.0862012 0.417765 0 0.638942 0 0.869565V6.95652C0 17.3913 10 20 10 20C10 20 5.11111 15.5 9 10.5C12.2958 6.26256 18 9 18 9Z",
				fill: "#4F92FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10 11.5V14H12.5",
				stroke: "#003C9D",
				strokeWidth: 1.3,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0434 18.1253C12.633 18.6818 13.3736 19.0522 14.1726 19.1902C14.9716 19.3282 15.7935 19.2278 16.5356 18.9013C17.2778 18.5749 17.9074 18.037 18.3456 17.3548C18.7838 16.6726 19.0113 15.8765 18.9996 15.0657C18.9879 14.255 18.7375 13.4657 18.2798 12.7965C17.8221 12.1272 17.1774 11.6077 16.4261 11.3028C15.6748 10.9979 14.8503 10.9211 14.0557 11.0821C13.261 11.2431 12.5314 11.6347 11.9581 12.208L10.5 13.5",
				stroke: "#003C9D",
				strokeWidth: 1.46259,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_30308_5680",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgAiFailShield;
